import { Button } from '@/components/ui/button';
import type { MessageDraftRevision } from '@/features/messaging/useMessageDraftLifecycle';

export function MessageDraftRevisionNotice({ revision }: { revision: MessageDraftRevision }) {
  if (revision.pending === null) {
    return null;
  }
  return (
    <div className="flex items-center gap-2 px-3 pb-1 text-xs text-muted-foreground" role="status">
      <span>Neo revised this draft</span>
      <Button type="button" variant="outline" size="sm" className="h-6 px-2 text-xs" onClick={revision.useRemote}>
        Use Neo's version
      </Button>
      <Button type="button" variant="ghost" size="sm" className="h-6 px-2 text-xs" onClick={revision.keepMine}>
        Keep mine
      </Button>
    </div>
  );
}
